import { LoggedOutLoyaltyInfo } from "@redotech/redo-model/loyalty/storefront-popup";
import { memo } from "react";
import { RedoButton } from "../../../arbiter-components/buttons/redo-button";
import { Flex } from "../../../flex";
import { Text } from "../../../text";
import { PopupHeader } from "./popup-header";

const SIGN_IN_PATH = "/account/login";
const SIGN_UP_PATH = "/account/register";

export const LoggedOutLoyaltyPopup = memo(function LoggedOutLoyaltyPopup({
  loyaltyInfo,
}: {
  loyaltyInfo: LoggedOutLoyaltyInfo;
}) {
  return (
    <Flex dir="column" gap="xl" w="full">
      <PopupHeader
        description="Join our loyalty program and save on future orders"
        title="Earn discount points"
      />
      {/* Promotions section */}
      {loyaltyInfo.pointsForPurchase > 0 && (
        <Text fontSize="xs" textColor="tertiary">
          You'll earn {loyaltyInfo.pointsForPurchase} points on this purchase.
        </Text>
      )}
      <Flex align="center" dir="row" gap="lg" w="full">
        <RedoButton
          flexGrow={1}
          hierarchy="secondary"
          onClick={() => {
            window.location.pathname = SIGN_IN_PATH;
          }}
          size="sm"
          text="Sign in"
        />
        <RedoButton
          flexGrow={1}
          hierarchy="primary"
          onClick={() => {
            window.location.pathname = SIGN_UP_PATH;
          }}
          size="sm"
          text="Sign up"
        />
      </Flex>
    </Flex>
  );
});
